import { EventHandler, FC, useCallback } from 'react';
import { CUSTOMER_CHANGE, useSessionServiceContext } from '@cld/session-service';
import { CustomerIdContextProvider } from '../../context';

export const CustomerIdProviderWithSession: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { sessionEvents } = useSessionServiceContext();
  // TODO: Provide better types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onCustomerChange = useCallback(<T extends EventHandler<any>>(fn: T) => sessionEvents?.on(CUSTOMER_CHANGE, fn), [sessionEvents]);
  const updateCurrentCustomer = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (customer: any) => {
      sessionEvents?.emit(CUSTOMER_CHANGE, customer);
    },
    [sessionEvents]
  );

  return (
    <CustomerIdContextProvider onCustomerChange={onCustomerChange} updateCurrentCustomer={updateCurrentCustomer}>
      {children}
    </CustomerIdContextProvider>
  );
};
